import { LogLevel } from './log-level';

/** Explicitly registers the names of loggers. */
export enum LoggerName {
  AppModule = 'AppModule',
  MyNinetyModule = 'MyNinetyModule',
}
export type LoggingFeatureFlagState = Record<LoggerName, LogLevel>;

export const InitialLoggingFeatureFlagState: LoggingFeatureFlagState = {
  AppModule: LogLevel.Info,
  MyNinetyModule: LogLevel.Info,
};
